import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import {reducer as reduxAsyncConnect} from 'redux-connect';

import auth from './auth';
import {reducer as form} from 'redux-form';
import dashboardRoot from '../../reducers/rootReducer';

const appReducer = combineReducers({
  routing: routerReducer,
  reduxAsyncConnect,
  auth,
  form,
  dashboardRoot
});

export default appReducer